<template>
  <div id="app">
    <div v-if="!paying">
    <div class="center">
      <h2 class="title">Payment</h2>
    </div>
    <form action="https://ccore.NewebPay.com/MPG/mpg_gateway" method="POST" target="_blank" id="form_pay">
      <div style="display:none;">
      <input name="MerchantID" v-model="info_mpg.merchantID"><br>
      <input name="TradeInfo" v-model="info_mpg.tradeInfo"><br>
      <input name="TradeSha" v-model="info_mpg.tradeSha"><br>
      <input name="Version" v-model="info_mpg.version"><br>
      </div>
      <v-card
      max-width="450"
      class="mx-auto">
      <v-list two-line>
        <v-list-item-group
          v-model="selected"
          multiple
        >
        <v-subheader>Images</v-subheader>
        <template v-for="(item) in list">
            <v-list-item :key="item.index" v-if="!item.paid" @click="confirm=true">
              <template v-slot:default="{ active }">
              <v-list-item-content>
                  <v-list-item-title>{{item.patient_name}} {{item.hospital}} </v-list-item-title>
                  <v-list-item-subtitle> {{item.token_id}}</v-list-item-subtitle>
                  <!-- <v-list-item-subtitle> {{item.uploaded_date}}</v-list-item-subtitle> -->
              </v-list-item-content>
              <v-icon
                  v-if="active"
                  color="#00BEFF">
                  mdi-checkbox-marked-circle
              </v-icon>
              <v-icon
                  v-else
                  color="#00BEFF">
                  mdi-circle-outline
              </v-icon>
              </template>
            </v-list-item>
        </template>
        </v-list-item-group>
      </v-list>
      <div class="center">
        <div v-if="confirm" class="py-20">
        <v-btn color="#00BEFF" outlined @click="pay">
          Confirm
        </v-btn>
        </div>
        <div class="py-20" v-else>
          <div class="py-20"><b>Payment Amount: {{selected.length*250}}</b></div>
        <v-btn color="#00BEFF" outlined @click="done">
          Pay Now
        </v-btn>
        </div>
      </div>
      </v-card>
     </form>  
    </div>
    <div v-else-if="payment_complete">
      <v-card
      max-width="450"
      class="mx-auto mt-20">
      <v-list two-line>
        <v-subheader style="color:green;">Payment successful</v-subheader>
        <template v-for="(item) in paid_list">
            <v-list-item :key="item.index" @click="clickpatient(item)">
            <v-list-item-content>
                <v-list-item-title>{{item.patient_name}}, {{item.hospital}} </v-list-item-title>
                <v-list-item-subtitle> {{item.token_id}}</v-list-item-subtitle>
                <!-- <v-list-item-subtitle> {{item.uploaded_date}}</v-list-item-subtitle> -->
            </v-list-item-content>
            <v-icon
              color="#00BEFF"
            >
              mdi-checkbox-marked-circle
            </v-icon>
            <div style=" margin-right:16px;" v-if="item.paid">paid</div>
            </v-list-item>
        </template>
      </v-list>
      <div class="center py-20">
      已完成付款，請至查看影像頁面檢視影像
      <div class="py-20">
      <v-btn color="#00BEFF" outlined :to="'/'">
        Go back
      </v-btn>
      </div>
      </div>
      </v-card>
    </div>
    <div v-else>
      <div class="center">
      <h2 class="title">Payment</h2>
      </div>
      <v-card
      max-width="450"
      class="mx-auto mt-20">
      <center style="color:green;">Please complete the payment</center>
      <!-- <v-list two-line>
        <v-subheader style="color:green;">Please complete the payment</v-subheader>
      </v-list> -->
      <div class="center py-20">
      <!-- 已完成付款，請至查看影像頁面檢視影像 -->
      <div class="py-20">
      <v-btn color="#00BEFF" outlined to="/">
        Cancel
      </v-btn>
      </div>
      </div>
      </v-card>
    </div>
    <v-snackbar v-model="select_error">
      Please select the image to pay.
    </v-snackbar>
  </div> 
</template>
<script>
import axios from 'axios'
export default {
  data(){
    return{
      confirm:true,
      info_mpg:{
      },
      user_information:{
        auth_token:'hi_im_token_123',
        amount_to_pay: ''
      },
      paying:false,
      payment_complete:false,
      image_data:[],
      check_list:[],
      selected:[],
      selected_pay:[],
      paid_list:[],
      select_error:false,
      list:[
        { 
          token_id:'aaa123',
          uploaded_date:'2021/10/1',
          patient_name:'§ xx',
          hospital:'NTUH',
          paid:true
        },
        { 
          token_id:'aaa234',
          uploaded_date:'2021/10/2',
          patient_name:'§ xxx',
          hospital:'MIMH',
          paid:false
        },
        { 
          token_id:'aaa1234',
          uploaded_date:'2021/10/12',
          patient_name:'§ xxx',
          hospital:'NTUHH',
          paid:false
        },
      ]
    }
  },
  async mounted(){
    for(let i=0;i<this.list.length;i++){
      if(this.list[i].paid==false)
      {
        this.check_list.push(this.list[i])
      }
    }


    let formData = new FormData()
    formData.append('DeviceID','HTC1234');
    let res = await axios.post('https://192.168.60.23:44340/api/GetOrderList',formData)
    this.image_data= res.data;
  },
  methods:{
    done(){
      // localStorage.setItem('selected',this.selected_pay);
      document.getElementById("form_pay").submit();
      this.paying = true
    },
    pay(){
      if(this.selected.length != 0){
        this.selected_pay=[]
        //exclude token id from selected
        let deviceIDParams = window.location.search; 
        console.log("deviceIDParams", deviceIDParams);
        //for testing
        deviceIDParams = "HTC1234";
        // let tokenId = ['aaa123', 'bbb234']
        //calling payment api to get parameters for mpg api
        const config = {
              headers: {"content-type": "multipart/form-data"},
        };
        let form = new FormData();
        form.append('deviceID', deviceIDParams);
        form.append('auth_token',this.user_information.auth_token);
        this.user_information.amount_to_pay = this.selected.length*250;
        form.append('amount_to_pay',this.user_information.amount_to_pay);
        for(let i=0;i<this.selected.length;i++)
        {
          form.append('tokenID', this.check_list[this.selected[i]].token_id);
          this.selected_pay.push(this.check_list[this.selected[i]].token_id);
          this.paid_list.push(this.check_list[this.selected[i]])
        }
        form.append('tokenNo', this.selected.length);
        for (var pair of form.entries()) {
            console.log(pair[0]+ ': ' + pair[1]); 
        }
        axios.post('https://fhrwebtest.ebmtech.com/api/Payments',form,config)
        .then( res => {
          console.log(res);
          this.info_mpg= res.data
          this.confirm= false
        }
            )
        .catch(error=>{
          console.log(error.response);
        })
      }else{
        this.select_error = true
      }
    }
  }   
}
</script>
<style scoped>
.center{
  text-align: center;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
  margin-bottom: 20px;
}
.title{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.py-20{
  padding-top: 20px;
  padding-bottom: 20px;
}
.mt-20{
  margin-top: 20px;
}
</style>